import { eq } from '@tanstack/db'
import { useLiveQuery } from '@tanstack/react-db'
import { useMemo } from 'react'
import { useStore } from '@/lib/pocketbase'
import { combineWithOr } from '@/lib/query-utils'
import type { Users } from '@/types/pbSchema'

export function useBatchUsers(userIds: string[]) {
    const [usersCollection] = useStore('users')

    const normalizedUserIds = useMemo(() => {
        return Array.from(new Set(userIds)).sort()
    }, [userIds])

    const { data: users = [], isLoading } = useLiveQuery(
        q =>
            normalizedUserIds.length > 0
                ? q
                      .from({ users: usersCollection })
                      .where(({ users }) =>
                          combineWithOr(normalizedUserIds.map(id => eq(users.id, id)))
                      )
                : undefined,
        [normalizedUserIds]
    )

    const userMap = useMemo(() => {
        const map = new Map<string, Users>()
        for (const user of users) {
            map.set(user.id, user)
        }
        return map
    }, [users])

    return {
        userMap,
        isPending: isLoading,
    }
}
